import 'core-js/stable';
import 'regenerator-runtime/runtime';

import('./bootstrap');
